import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FingerprintIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fingerprint"}/>
}
